// extracted by mini-css-extract-plugin
export default {"genericCard":"Yu-z","inline":"Zu-z","mastercard":"_u-z","discover":"av-z","visa":"bv-z","amex":"cv-z","active":"dv-z"};